<template>
  <span />
</template>

<script>
import { propValidator, PROP_TYPES } from '@fmpedia/validators'
import { removeEndingSlashes, parseUrl } from '@/plugins/helper'

export default {
  name: 'AScript',
  props: {
    src: propValidator([PROP_TYPES.STRING], false)
  },
  data() {
    return { script: null }
  },
  computed: {
    srcAddress() {
      return removeEndingSlashes(parseUrl(this.src).address)
    }
  },
  methods: {
    addScript() {
      if (!this.src && !this.$slots.default) return

      this.script = document.createElement('script')
      this.script.type = 'text/javascript'

      if (this.src) {
        this.script.src = this.src
      } else {
        this.script.innerText = this.$slots.default[0].text
      }

      this.$el.parentNode.replaceChild(this.script, this.$el)
    }
  },
  mounted() {
    this.addScript()
  },
  beforeDestroy() {
    if (this.script) {
      this.script.parentElement.removeChild(this.script)
    }
  }
}
</script>
